import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  catchError,
  first,
  map,
  Observable,
  shareReplay,
  throwError,
} from 'rxjs';

import { NavigationService } from '../../navigation/service/navigation.service';
import { BrandingApi } from '../api/branding.api';
import { BrandNotFoundError } from '../api/error/brand-not-found-error';
import { Brand } from '../api/model/brand';

@Injectable()
export class BrandingService {
  public branding$: Observable<Brand> = this.brandingApi.getBranding().pipe(
    first(),
    catchError((err: unknown) => {
      if (
        (err instanceof HttpErrorResponse && err.status === 404) ||
        err instanceof BrandNotFoundError
      ) {
        this.navigationService.navigateTo404Page();
      }

      return throwError(() => err);
    }),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  constructor(
    private readonly brandingApi: BrandingApi,
    private readonly navigationService: NavigationService,
  ) {}

  logoDataUrl() {
    return this.branding$.pipe(map((brand) => brand.applicationLogo));
  }

  clientPortalLogoDataUrl() {
    return this.branding$.pipe(map((brand) => brand.clientPortalLogo));
  }

  brandName() {
    return this.branding$.pipe(map((brand) => brand.name));
  }

  mapLogo() {
    return this.branding$.pipe(map((brand) => brand.mapLogo));
  }
}
